<!--
 * @FileDescription: 文档预览
 * @Author: wh
 * @Date: null
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-18 12:41:37
-->
<template>
  <yxt-dialog
    :title="title"
    custom-class="pd-view-doc-container"
    :visible.sync="show"
    width="100%"
    :cutline="false"
    :append-to-body="true"
  >
    <yxtbiz-doc-viewer
      v-if="show"
      :file-id="fileId"
      :file-info="fileInfo"
      style="height: 100%;"
      :show-zoom="false"
    />
  </yxt-dialog>
</template>

<script>
export default {
  data() {
    return {
      fileId: '',
      fileInfo: {
        width: 0,
        height: 0,
        list: []
      },
      show: false,
      title: ''
    };
  },
  methods: {
    init(id, option, name) {
      this.fileInfo = option;
      this.fileId = id;
      this.show = true;
      this.title = name.split('.')[0];
    }
  }
};
</script>
<style lang="scss">
.pd-view-doc-container {
  height: 100% !important;
  max-height: 100% !important;
  border-radius: 0;

  .yxt-dialog__body {
    height: 100%;
    padding: 0;
  }

  .yxt-scrollbar__view {
    height: 100%;
  }
}
</style>
